import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-info",
  "use": "icon-info-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-info\"><path d=\"M512 960a448 448 0 1 1 448-448 448 448 0 0 1-448 448z m0-800a352 352 0 1 0 352 352A352 352 0 0 0 512 160z m-64 288h128v320h-128V448z m0-192h128v128h-128V256z\" fill=\"#2c2c2c\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol